export const SET_USER_INFO = 'SET_USER_INFO'

export const SET_CAMPAIGN_LIST = 'SET_CAMPAIGN_LIST'

export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'

export const SET_CAMPAIGN_INFO = 'SET_CAMPAIGN_INFO'

export const SET_CONTRACT_DATA = 'SET_CONTRACT_DATA'

export const SET_SIZE_DATA = 'SET_SIZE_DATA'

export const SET_CREATIVE_DATA = 'SET_CREATIVE_DATA'

export const SET_CREATIVE_GROUP_DATA = 'SET_CREATIVE_GROUP_DATA'

export const SET_GEO_DATA = 'SET_GEO_DATA'

// notoice module
export const SET_NOTICE_LIST = 'notice/SET_NOTICE_LIST'

export const SET_NOTICE_PAGE = 'notice/SET_NOTICE_PAGE'

// promotion module
export const SET_PROMO_LIST = 'promo/SET_PROMO_LIST'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js